// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rev_slider_wrapper {
  position: relative;
  width: 100%;
  overflow: hidden;
}
.rev_slider .slotholder:before {
    position: absolute;
    content: "";
    height: 100%;
    width: 100%;
    background: rgba(65, 58, 164, .7);
    z-index: 99;
}
.rev_slider {
  position: relative;
  width: 100%;
}

.slide {
  position: relative;
  width: 100%;
  height: 100vh; /* Full viewport height, adjust as needed */
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.rev_row_zone {
  position: relative;
  width: 100%;
}

.slide-content {
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  transform: translateY(-50%);
}

.column {
  display: inline-block;
  vertical-align: top;
}

.title {
  animation: fadeIn 1.5s ease-in-out;
}

.description {
  animation: slideUp 2s ease-in-out 1.07s both;
}

.button-group a {
  animation: fadeIn 0.3s ease-in-out;
}

.button-group a:nth-child(1) {
  animation-delay: 2.29s;
}

.button-group a:nth-child(2) {
  animation-delay: 2.55s;
}

/* Animations to mimic Revolution Slider */
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes slideUp {
  from {
    transform: translateY(100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

/* Button styles */
.btn {
  padding: 10px 20px;
  border-radius: 25px;
  text-decoration: none;
  transition: all 0.3s ease;
}

.btn-secondary {
  background-color: #007bff; /* Adjust color as needed */
  color: #ffffff;
}

.btn-secondary:hover {
  background-color: #0056b3;
}

.btn-outline-light {
  border: 1px solid #ffffff;
  color: #ffffff;
}

.btn-outline-light:hover {
  background-color: #ffffff;
  color: #000000;
}

/* Responsive adjustments */
@media (max-width: 1024px) {
  .title {
    font-size: 50px;
    line-height: 60px;
  }
}

@media (max-width: 768px) {
  .title {
    font-size: 40px;
    line-height: 43px;
  }
  .description {
    font-size: 18px;
    line-height: 24px;
  }
}

@media (max-width: 480px) {
  .title {
    font-size: 32px;
    line-height: 38px;
  }
  .description {
    font-size: 16px;
    line-height: 22px;
  }
  .button-group a {
    margin-left: 15px;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/css/SliderHome.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,iCAAiC;IACjC,WAAW;AACf;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa,EAAE,2CAA2C;EAC1D,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,0CAA0C;AAC1C;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB,EAAE,2BAA2B;EACtD,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".rev_slider_wrapper {\r\n  position: relative;\r\n  width: 100%;\r\n  overflow: hidden;\r\n}\r\n.rev_slider .slotholder:before {\r\n    position: absolute;\r\n    content: \"\";\r\n    height: 100%;\r\n    width: 100%;\r\n    background: rgba(65, 58, 164, .7);\r\n    z-index: 99;\r\n}\r\n.rev_slider {\r\n  position: relative;\r\n  width: 100%;\r\n}\r\n\r\n.slide {\r\n  position: relative;\r\n  width: 100%;\r\n  height: 100vh; /* Full viewport height, adjust as needed */\r\n  background-size: cover;\r\n  background-position: center;\r\n  background-repeat: no-repeat;\r\n}\r\n\r\n.rev_row_zone {\r\n  position: relative;\r\n  width: 100%;\r\n}\r\n\r\n.slide-content {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 0;\r\n  width: 100%;\r\n  transform: translateY(-50%);\r\n}\r\n\r\n.column {\r\n  display: inline-block;\r\n  vertical-align: top;\r\n}\r\n\r\n.title {\r\n  animation: fadeIn 1.5s ease-in-out;\r\n}\r\n\r\n.description {\r\n  animation: slideUp 2s ease-in-out 1.07s both;\r\n}\r\n\r\n.button-group a {\r\n  animation: fadeIn 0.3s ease-in-out;\r\n}\r\n\r\n.button-group a:nth-child(1) {\r\n  animation-delay: 2.29s;\r\n}\r\n\r\n.button-group a:nth-child(2) {\r\n  animation-delay: 2.55s;\r\n}\r\n\r\n/* Animations to mimic Revolution Slider */\r\n@keyframes fadeIn {\r\n  from {\r\n    opacity: 0;\r\n  }\r\n  to {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n@keyframes slideUp {\r\n  from {\r\n    transform: translateY(100%);\r\n    opacity: 0;\r\n  }\r\n  to {\r\n    transform: translateY(0);\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n/* Button styles */\r\n.btn {\r\n  padding: 10px 20px;\r\n  border-radius: 25px;\r\n  text-decoration: none;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.btn-secondary {\r\n  background-color: #007bff; /* Adjust color as needed */\r\n  color: #ffffff;\r\n}\r\n\r\n.btn-secondary:hover {\r\n  background-color: #0056b3;\r\n}\r\n\r\n.btn-outline-light {\r\n  border: 1px solid #ffffff;\r\n  color: #ffffff;\r\n}\r\n\r\n.btn-outline-light:hover {\r\n  background-color: #ffffff;\r\n  color: #000000;\r\n}\r\n\r\n/* Responsive adjustments */\r\n@media (max-width: 1024px) {\r\n  .title {\r\n    font-size: 50px;\r\n    line-height: 60px;\r\n  }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .title {\r\n    font-size: 40px;\r\n    line-height: 43px;\r\n  }\r\n  .description {\r\n    font-size: 18px;\r\n    line-height: 24px;\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .title {\r\n    font-size: 32px;\r\n    line-height: 38px;\r\n  }\r\n  .description {\r\n    font-size: 16px;\r\n    line-height: 22px;\r\n  }\r\n  .button-group a {\r\n    margin-left: 15px;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
